module.exports = __webpack_public_path__ + "static/MessageBirdProcedure-fc14e0e5f01d60c19acb1d293cb059c0.png";